import React, { useEffect, useState } from 'react'
import { AuthContext, getUsername, getUserPrivileges } from 'context/auth'
import { TOKEN_KEY } from 'Constants'
import {fetchGlobalConfig, fetchLoggedUser} from 'services'
import { useErrorHandling } from 'context/errorHandling'

function containsAnyOrEmpty (subset, superset) {
  return subset.length === 0 || subset.some(item => superset.includes(item))
}

const getHasAnyPrivilegesFun = (authTokens, userPrivileges) => (privilegesToCheck) => {
  return authTokens && userPrivileges && containsAnyOrEmpty(privilegesToCheck, userPrivileges)
}

export const AuthContextProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = useState()
  const [user, setUser] = useState(null)
  const [globalConfig, setGlobalConfig] = useState(null)

  const { handleError } = useErrorHandling()

  const username = authTokens ? getUsername(authTokens) : null
  const userPrivileges = authTokens ? getUserPrivileges(authTokens) : null

  const hasAnyPrivileges = getHasAnyPrivilegesFun(authTokens, userPrivileges)

  const hasRole = (expectedRole) => {
    return user?.role === expectedRole
  }

  const setTokens = (data) => {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(data))
    setAuthTokens(data)
  }

  useEffect(() => {
    const tokenFromLocalStorage = JSON.parse(localStorage.getItem(TOKEN_KEY))
    if (tokenFromLocalStorage && !getUserPrivileges(tokenFromLocalStorage)) {
      localStorage.removeItem(TOKEN_KEY)
    } else if (!authTokens && tokenFromLocalStorage) {
      setAuthTokens(tokenFromLocalStorage)
    }
  }, [authTokens])


  useEffect(() => {
    if (authTokens) {
      fetchLoggedUser()
        .then(setUser)
        .catch(handleError)
      fetchGlobalConfig()
        .then(setGlobalConfig)
        .catch(handleError)
    } else {
      setUser(null)
    }
  }, [authTokens, handleError])



  return <AuthContext.Provider value={{
    authTokens,
    username,
    hasRole,
    hasAnyPrivileges,
    user,
    globalConfig,
    setGlobalConfig,
    setAuthTokens: setTokens
  }}>
    {children}
  </AuthContext.Provider>
}
